import * as React from 'react';
import { Badge, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { ClearAll, Delete } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

import { IEnhancedTableCheckboxFilter, IEnhancedTableTextFilter } from 'models';
import { isAppliedFilters } from 'utils';

export interface EnhancedTableToolbarProps {
  title: string;
  numSelected: number;
  defaultCheckboxFilters: IEnhancedTableCheckboxFilter;
  checkboxFilters: IEnhancedTableCheckboxFilter;
  textFilters: IEnhancedTableTextFilter;
  hideclearFilters?: boolean;
  clearFilters: () => void;
  onDelete: (payload: any) => void;
}

export const EnhancedTableToolbar: React.FC<EnhancedTableToolbarProps> = (props) => {
  const {
    title,
    numSelected,
    defaultCheckboxFilters,
    checkboxFilters,
    textFilters,
    hideclearFilters,
    clearFilters,
    onDelete,
  } = props;

  const useStyles = makeStyles({
    highlight: {
      color: 'red',
    },

    title: {
      '&&': {
        flex: '1 1 100%',
      },
    },
  });

  const classes = useStyles();

  return (
    <Toolbar>
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          {title}
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" onClick={onDelete}>
            <Delete />
          </IconButton>
        </Tooltip>
      ) : hideclearFilters ? null : (
        <Tooltip title="Clear all filters">
          <IconButton aria-label="filter list" onClick={() => clearFilters()}>
            <Badge
              color="secondary"
              variant="dot"
              invisible={!isAppliedFilters(defaultCheckboxFilters, checkboxFilters, textFilters)}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <ClearAll />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};
